import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AiKnowledgeBaseQaPairValidation } from 'uplisting-frontend/validations';

export default class KnowledgeBaseQaPairRepositoryService extends BaseRepositoryService<
  ModelRegistry['ai-knowledge-base-qa-pair']
> {
  recordName = 'ai-knowledge-base-qa-pair';
  implementMethods = ['findAll', 'createRecord', 'buildChangeset', 'query'];

  validation = AiKnowledgeBaseQaPairValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/ai-knowledge-base-qa-pair': KnowledgeBaseQaPairRepositoryService;
  }
}
